<template>
  <el-dialog class="dialog-volunteer-detail" :append-to-body="true" :visible.sync="dialogVisible" title="详情" width="1000px">
    <div class="wrap">
      <el-tabs class="content-tabs" v-model="activeName" @tab-click="handleClickTab">
        <!-- <el-tab-pane label="基本信息" name="1"> -->
          <el-row :gutter="20">
            <el-col :span="12">
              <div class="g-label-box mb-20">
                <span class="g-label-name">单位名称 :</span>
                <span class="g-label-txt">{{detailData.orgName}}</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="g-label-box mb-20">
                <span class="g-label-name">联系地址 :</span>
                <span class="g-label-txt">{{detailData.orgAddress}}</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="g-label-box mb-20">
                <span class="g-label-name">联系人 :</span>
                <span class="g-label-txt">{{detailData.headName}}</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="g-label-box mb-20">
                <span class="g-label-name">证件号 :</span>
                <span class="g-label-txt">{{detailData.headIdentificationNumber}}</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="g-label-box mb-20">
                <span class="g-label-name">手机号码 :</span>
                <span class="g-label-txt">{{detailData.headPhone}}</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="g-label-box mb-20">
                <span class="g-label-name">参与人数 :</span>
                <span class="g-label-txt">{{detailData.peopleNumber}}</span>
              </div>
            </el-col>

            <!-- 流动服务 -->
            <template v-if="detailData.activityType=='1'">
              <el-col :span="12">
                <div class="g-label-box mb-20">
                  <span class="g-label-name">拟举办活动时间 :</span>
                  <span class="g-label-txt" v-show="detailData.startDate && detailData.endDate">{{`${detailData.startDate} 至 ${detailData.endDate}`}}</span>
                </div>
              </el-col>

              <el-col :span="12">
                <div class="g-label-box mb-20">
                  <span class="g-label-name">活动地点 :</span>
                  <span class="g-label-txt">{{detailData.activityPlace}}</span>
                </div>
              </el-col>

              <el-col :span="12">
                <div class="g-label-box mb-20">
                  <span class="g-label-name">场地容量 :</span>
                  <span class="g-label-txt">{{detailData.siteArea}}</span>
                </div>
              </el-col>
            </template>

            <!-- 进校园 -->
            <template v-if="detailData.activityType!=='1'">
            <!-- <template v-if="detailData.activityType=='2'"> -->
              <el-col :span="12">
                <div class="g-label-box mb-20">
                  <span class="g-label-name">拟举办活动时间 :</span>
                  <span class="g-label-txt" v-show="detailData.startDate && detailData.endDate">{{`${detailData.startDate} 至 ${detailData.endDate}`}}</span>
                </div>
              </el-col>

              <el-col :span="12">
                <div class="g-label-box mb-20">
                  <span class="g-label-name">活动地点 :</span>
                  <span class="g-label-txt">{{detailData.activityPlace}}</span>
                </div>
              </el-col>

              <el-col :span="12">
                <div class="g-label-box mb-20">
                  <span class="g-label-name">场地容量 :</span>
                  <span class="g-label-txt">{{detailData.siteArea}}</span>
                </div>
              </el-col>

              <el-col :span="12">
                <div class="g-label-box mb-20">
                  <span class="g-label-name">是否有扩音器 :</span>
                  <span class="g-label-txt">{{detailData.megaphone}}</span>
                </div>
              </el-col>

              <el-col :span="12">
                <div class="g-label-box mb-20">
                  <span class="g-label-name">是否能播放PPT课件 :</span>
                  <span class="g-label-txt">{{detailData.ppt}}</span>
                </div>
              </el-col>

              <el-col :span="12">
                <div class="g-label-box mb-20">
                  <span class="g-label-name">送展内容 :</span>
                  <span class="g-label-txt">{{detailData.activityContent}}</span>
                </div>
              </el-col>
            </template>

            <el-col :span="12">
              <div class="g-label-box mb-20">
                <span class="g-label-name">申请说明 :</span>
                <span class="g-label-txt">{{detailData.applyInfo}}</span>
              </div>
            </el-col>
            <!-- <el-col :span="12">
              <div class="g-label-box mb-20">
                <span class="g-label-name">状态 :</span>
                <span class="g-label-txt">{{detailData.approveStatus}}</span>
              </div>
            </el-col>
             -->
            <el-col :span="24" v-if="detailData.approveStatus === '2'">
              <div class="g-label-box mb-20">
                <span class="g-label-name">拒绝原因 :</span>
                <span class="g-label-txt">{{detailData.approvalInfo}}</span>
              </div>
            </el-col>
            <el-col :span="24">
              <div class="g-label-box mb-20">
                <span class="g-label-name">机构营业执照 :</span>
                <!-- <span class="g-label-txt"> -->
                  <viewer class="g-label-txt" :options="{ url: 'data-maxUrl' }">
                    <img class="g-pointer" :src="detailData.orgPicture"
                      :data-maxUrl="detailData.orgPicture" alt :onerror="defaultImg"
                      style="width: 150px;">
                  </viewer>
                   <!-- <img style="width:150px;" :src="detailData.orgPicture" alt></img> -->
                <!-- </span> -->
              </div>
            </el-col>

            <el-col :span="24">
              <div class="g-label-box mb-20">
                <span class="g-label-name">身份证照片 :</span>
                <viewer class="g-label-txt" :options="{ url: 'data-maxUrl' }">
                  <img class="g-pointer" :src="detailData.idcardPicFront"
                    :data-maxUrl="detailData.idcardPicFront" alt :onerror="defaultImg"
                    style="width: 150px;">

                  <img class="g-pointer" :src="detailData.idcardPicBack"
                    :data-maxUrl="detailData.idcardPicBack" alt :onerror="defaultImg"
                    style="width: 150px;margin-left: 20px;">
                </viewer>
                <!-- <span class="g-label-txt">
                   <img style="width:150px;" :src="detailData.idcardPicFront" alt></img>

                   <img style="width:150px;margin-left: 20px;" :src="detailData.idcardPicFront" alt></img>
                </span> -->
              </div>
            </el-col>
          </el-row>
        <!-- </el-tab-pane> -->
        <!-- <el-tab-pane label="照片" name="6">
          <div class="tc">
            <img style="width:150px;" :src="detailData.image" alt>
          </div>
        </el-tab-pane> -->
      </el-tabs>
    </div>

    <!-- 审批状态 0 待审批 1 已通过 2 已拒绝 -->
    <div slot="footer" class="footer mt-30" v-if="detailData.approveStatus === '0'">
      <el-button @click="handleClick('refuse')">拒绝</el-button>
      <el-button @click="handleClick('ok')" type="primary" :loading="loadingSave">审批通过</el-button>
    </div>
    <!-- <div slot="footer" class="footer mt-30" v-else>
      <el-button @click="dialogVisible=false">关闭</el-button>
    </div> -->

    <dialogArea ref="dialogArea" :approveTitle="'审批'" @closePanel="closePanel"></dialogArea>
  </el-dialog>
</template>

<script>
import dialogArea from './dialog-area' // 审批面板
export default {
  components: {
    dialogArea
  },
  data() {
    return {
      defaultImg: this.$store.state.app.defaultImg,
      pageType: '', // deital 详情 check 审核
      activeName: '1',
      dialogVisible: false,
      form: {},
      detailId: '',
      detailData: {},
      loadingSave: false
    }
  },
  methods: {
    init(id, type) {
      this.detailId = id
      this.pageType = type
      this.dialogVisible = true
      this.getDetail()
    },
    getDetail() {
      this.$http.get('/activitynew/team/common/orderDetail', {
        orderId: this.detailId
      }).then(res => {
        if (res.success) {
          this.detailData = res.result
        } else {
          this.$message.error(res.message)
        }
      })
    },
    handleClick(type) {
      this.$refs.dialogArea.init(this.detailId, type)
    },
    handleClickTab() {
      switch (this.activeName) {
        case '1':
          this.getDetail()
          break
        default:
          break
      }
    }, 
    closePanel() {
      this.$emit('refresh')
      this.dialogVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-volunteer-detail {
  .wrap {
    // height: 420px;
  }

  .g-label-name {
    width: 160px;
  }
}
</style>
